module.exports = __webpack_public_path__ + "static/media/kot_logo@2x.a9a0934b.png";